import { ReactComponent as AddUser } from "@svgr/webpack?-svgo,+titleProp,+ref!./AddUser.svg";
import { ReactComponent as Add } from "@svgr/webpack?-svgo,+titleProp,+ref!./Add.svg";
import { ReactComponent as Audience } from "@svgr/webpack?-svgo,+titleProp,+ref!./Audience.svg";
import { ReactComponent as Bandsintown } from "@svgr/webpack?-svgo,+titleProp,+ref!./Bandsintown.svg";
import { ReactComponent as Bell } from "@svgr/webpack?-svgo,+titleProp,+ref!./Bell.svg";
import { ReactComponent as Book } from "@svgr/webpack?-svgo,+titleProp,+ref!./Book.svg";
import { ReactComponent as Brand } from "@svgr/webpack?-svgo,+titleProp,+ref!./Brand.svg";
import { ReactComponent as Calendar } from "@svgr/webpack?-svgo,+titleProp,+ref!./Calendar.svg";
import { ReactComponent as Camera } from "@svgr/webpack?-svgo,+titleProp,+ref!./Camera.svg";
import { ReactComponent as Clipboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Clipboard.svg";
import { ReactComponent as ContactCard } from "@svgr/webpack?-svgo,+titleProp,+ref!./ContactCard.svg";
import { ReactComponent as CurrentLocation } from "@svgr/webpack?-svgo,+titleProp,+ref!./CurrentLocation.svg";
import { ReactComponent as Dashboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Dashboard.svg";
import { ReactComponent as Delete } from "@svgr/webpack?-svgo,+titleProp,+ref!./Delete.svg";
import { ReactComponent as Description } from "@svgr/webpack?-svgo,+titleProp,+ref!./Description.svg";
import { ReactComponent as Down } from "@svgr/webpack?-svgo,+titleProp,+ref!./Down.svg";
import { ReactComponent as Download } from "@svgr/webpack?-svgo,+titleProp,+ref!./Download.svg";
import { ReactComponent as Duplicate } from "@svgr/webpack?-svgo,+titleProp,+ref!./Duplicate.svg";
import { ReactComponent as Edit } from "@svgr/webpack?-svgo,+titleProp,+ref!./Edit.svg";
import { ReactComponent as Email } from "@svgr/webpack?-svgo,+titleProp,+ref!./Email.svg";
import { ReactComponent as Exit } from "@svgr/webpack?-svgo,+titleProp,+ref!./Exit.svg";
import { ReactComponent as Expand } from "@svgr/webpack?-svgo,+titleProp,+ref!./Expand.svg";
import { ReactComponent as Export } from "@svgr/webpack?-svgo,+titleProp,+ref!./Export.svg";
import { ReactComponent as Facebook } from "@svgr/webpack?-svgo,+titleProp,+ref!./Facebook.svg";
import { ReactComponent as Filter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Filter.svg";
import { ReactComponent as Flag } from "@svgr/webpack?-svgo,+titleProp,+ref!./Flag.svg";
import { ReactComponent as Gallery } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gallery.svg";
import { ReactComponent as Gear } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gear.svg";
import { ReactComponent as Import } from "@svgr/webpack?-svgo,+titleProp,+ref!./Import.svg";
import { ReactComponent as Instagram } from "@svgr/webpack?-svgo,+titleProp,+ref!./Instagram.svg";
import { ReactComponent as Left } from "@svgr/webpack?-svgo,+titleProp,+ref!./Left.svg";
import { ReactComponent as Link } from "@svgr/webpack?-svgo,+titleProp,+ref!./Link.svg";
import { ReactComponent as Lock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Lock.svg";
import { ReactComponent as MAX } from "@svgr/webpack?-svgo,+titleProp,+ref!./MAX.svg";
import { ReactComponent as Message } from "@svgr/webpack?-svgo,+titleProp,+ref!./Message.svg";
import { ReactComponent as Messenger } from "@svgr/webpack?-svgo,+titleProp,+ref!./Messenger.svg";
import { ReactComponent as Next } from "@svgr/webpack?-svgo,+titleProp,+ref!./Next.svg";
import { ReactComponent as Pandora } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pandora.svg";
import { ReactComponent as Pencil } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pencil.svg";
import { ReactComponent as Preview } from "@svgr/webpack?-svgo,+titleProp,+ref!./Preview.svg";
import { ReactComponent as Previous } from "@svgr/webpack?-svgo,+titleProp,+ref!./Previous.svg";
import { ReactComponent as Refresh } from "@svgr/webpack?-svgo,+titleProp,+ref!./Refresh.svg";
import { ReactComponent as Remove } from "@svgr/webpack?-svgo,+titleProp,+ref!./Remove.svg";
import { ReactComponent as Report } from "@svgr/webpack?-svgo,+titleProp,+ref!./Report.svg";
import { ReactComponent as Right } from "@svgr/webpack?-svgo,+titleProp,+ref!./Right.svg";
import { ReactComponent as Search } from "@svgr/webpack?-svgo,+titleProp,+ref!./Search.svg";
import { ReactComponent as Send } from "@svgr/webpack?-svgo,+titleProp,+ref!./Send.svg";
import { ReactComponent as Shuffle } from "@svgr/webpack?-svgo,+titleProp,+ref!./Shuffle.svg";
import { ReactComponent as SoundCloud } from "@svgr/webpack?-svgo,+titleProp,+ref!./SoundCloud.svg";
import { ReactComponent as Spotify } from "@svgr/webpack?-svgo,+titleProp,+ref!./Spotify.svg";
import { ReactComponent as Subtract } from "@svgr/webpack?-svgo,+titleProp,+ref!./Subtract.svg";
import { ReactComponent as Ticket } from "@svgr/webpack?-svgo,+titleProp,+ref!./Ticket.svg";
import { ReactComponent as Twitter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Twitter.svg";
import { ReactComponent as Unlink } from "@svgr/webpack?-svgo,+titleProp,+ref!./Unlink.svg";
import { ReactComponent as Up } from "@svgr/webpack?-svgo,+titleProp,+ref!./Up.svg";
import { ReactComponent as Update } from "@svgr/webpack?-svgo,+titleProp,+ref!./Update.svg";
import { ReactComponent as Upload } from "@svgr/webpack?-svgo,+titleProp,+ref!./Upload.svg";
import { ReactComponent as USD } from "@svgr/webpack?-svgo,+titleProp,+ref!./USD.svg";
import { ReactComponent as User } from "@svgr/webpack?-svgo,+titleProp,+ref!./User.svg";
import { ReactComponent as Video } from "@svgr/webpack?-svgo,+titleProp,+ref!./Video.svg";
import { ReactComponent as Wikipedia } from "@svgr/webpack?-svgo,+titleProp,+ref!./Wikipedia.svg";
import { ReactComponent as YouTube } from "@svgr/webpack?-svgo,+titleProp,+ref!./YouTube.svg";
import { ReactComponent as CalendarAdd } from "@svgr/webpack?-svgo,+titleProp,+ref!./CalendarAdd.svg";
import { ReactComponent as Music } from "@svgr/webpack?-svgo,+titleProp,+ref!./Music.svg";
import { ReactComponent as Pin } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pin.svg";
import { ReactComponent as Trophy } from "@svgr/webpack?-svgo,+titleProp,+ref!./Trophy.svg";
import { ReactComponent as MoveDown } from "@svgr/webpack?-svgo,+titleProp,+ref!./MoveDown.svg";
import { ReactComponent as MoveUp } from "@svgr/webpack?-svgo,+titleProp,+ref!./MoveUp.svg";
import { ReactComponent as Archive } from "@svgr/webpack?-svgo,+titleProp,+ref!./Archive.svg";
import { ReactComponent as Clock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Clock.svg";
import { ReactComponent as QuestionHighlight } from "@svgr/webpack?-svgo,+titleProp,+ref!./QuestionHighlight.svg";
export const TertiaryIcons = {
  AddUser,
  Add,
  Audience,
  Bandsintown,
  Bell,
  Book,
  Brand,
  Calendar,
  Camera,
  Clipboard,
  ContactCard,
  CurrentLocation,
  Dashboard,
  Delete,
  Description,
  Down,
  Download,
  Duplicate,
  Edit,
  Email,
  Exit,
  Expand,
  Export,
  Facebook,
  Filter,
  Flag,
  Gallery,
  Gear,
  Import,
  Instagram,
  Left,
  Link,
  Lock,
  MAX,
  Message,
  Messenger,
  Next,
  Pandora,
  Pencil,
  Preview,
  Previous,
  Refresh,
  Remove,
  Report,
  Right,
  Search,
  Send,
  Shuffle,
  SoundCloud,
  Spotify,
  Subtract,
  Ticket,
  Twitter,
  Unlink,
  Up,
  Update,
  Upload,
  USD,
  User,
  Video,
  Wikipedia,
  YouTube,
  CalendarAdd,
  Trophy,
  Pin,
  Music,
  CalendarAdd,
  MoveUp,
  MoveDown,
  Archive,
  Clock,
  QuestionHighlight
};
export const TertiaryIconNames = ["AddUser", "Add", "Audience", "Bandsintown", "Bell", "Book", "Brand", "Calendar", "Camera", "Clipboard", "ContactCard", "CurrentLocation", "Dashboard", "Delete", "Description", "Down", "Download", "Duplicate", "Edit", "Email", "Exit", "Expand", "Export", "Facebook", "Filter", "Flag", "Gallery", "Gear", "Import", "Instagram", "Left", "Link", "Lock", "MAX", "Message", "Messenger", "Next", "Pandora", "Pencil", "Preview", "Previous", "Refresh", "Remove", "Report", "Right", "Search", "Send", "Shuffle", "SoundCloud", "Spotify", "Subtract", "Ticket", "Twitter", "Unlink", "Up", "Update", "Upload", "USD", "User", "Video", "Wikipedia", "YouTube", "CalendarAdd", "Trophy", "Pin", "Music", "MoveUp", "MoveDown", "Archive", "Clock", "QuestionHighlight"];